import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { DistraintType, InternationalTribunalJobType, } from '@debbie/common/dist/tribunal/jobs/types.js';
import { Button, Input, SearchInput, AddressInput, DateInput } from '../../../index.js';
import MoneyInput from '../../../MoneyInput.js';
import q from '@debbie/cortex/dist/query.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
const RegisterDistraint = (props) => {
    const lang = useSelector((s) => s.lang);
    const [loading, setLoading] = useState(false);
    const [fsNo, setFsNo] = useState(props.tribunalCase.reference ?? 'FS');
    const [distraintType, setDistraintType] = useState(DistraintType.Property);
    const [address, setAddress] = useState(null);
    const [VIN, setVIN] = useState('');
    const [licenseplate, setLicenseplate] = useState('');
    const [comment, setComment] = useState('');
    const [amount, setAmount] = useState(null);
    const [date, setdate] = useState(null);
    const [referenceId, setReferenceId] = useState(null);
    const registerDistress = async () => {
        setLoading(true);
        try {
            if (!distraintType) {
                throw new Error('Type is required');
            }
            if (!comment) {
                throw new Error('Comment is required');
            }
            await tribunalAPI.createTribunalJob({
                type: InternationalTribunalJobType.Distraint,
                tribunalCaseId: props.tribunalCase.id,
                data: {
                    distraintType: distraintType,
                    distraint: {
                        comment: comment || null,
                        amount: amount || null,
                        VIN: VIN || undefined,
                        licenseplate: licenseplate || undefined,
                        address: address || undefined,
                        date: date?.format() || null,
                        referenceId: referenceId,
                    },
                },
                caseId: props.tribunalCase.caseId,
                reference: `${fsNo}`.trim(),
            });
            props.onSubmit();
        }
        catch (err) {
            console.error(err);
            alert(err.message);
        }
        setLoading(false);
        q.invalidate(keys.write.create(tribunalJobsEntity));
    };
    return (React.createElement("div", null,
        React.createElement("h4", null, lang.tribunal.registerDistraint),
        !props.tribunalCase.reference && (React.createElement(Input, { placeholder: lang.tribunal.fsNo, value: fsNo, onChange: (e) => {
                setFsNo(e.target.value);
            } })),
        React.createElement(SearchInput, { placeholder: lang.tribunal.selectDistraintType, searchAll: (q) => {
                return Object.values(DistraintType)
                    .filter((type) => `${type} ${lang.distraintType[type]}`
                    .toLowerCase()
                    .indexOf(q.toLowerCase()) !== -1)
                    .map((type) => ({
                    key: type,
                    heading: lang.distraintType[type] ?? type,
                    returnData: type,
                }));
            }, onRemoveStatic: () => {
                setDistraintType(null);
            }, static: lang.distraintType[distraintType], onSelect: (type) => {
                setDistraintType(type);
            }, searchDelay: 0, forceOpen: true }),
        (distraintType === DistraintType.Property ||
            distraintType === DistraintType.RentDepositum ||
            distraintType === DistraintType.CooperativeHousing ||
            distraintType === DistraintType.MorgageDeed) && (React.createElement(AddressInput, { address: address, onChange: (a) => {
                setAddress(a);
            } })),
        distraintType === DistraintType.Vehicle && (React.createElement(React.Fragment, null,
            React.createElement(Input, { placeholder: lang.tribunal.vin, value: VIN, onChange: (e) => {
                    setVIN(e.target.value);
                } }),
            React.createElement(Input, { placeholder: lang.tribunal.licenseplate, value: licenseplate, onChange: (e) => {
                    setLicenseplate(e.target.value);
                } }))),
        React.createElement(Input, { placeholder: lang.tribunal.comment, value: comment, onChange: (e) => {
                setComment(e.target.value);
            } }),
        React.createElement(MoneyInput, { placeholder: lang.tribunal.amount, value: amount, onChange: (e) => {
                setAmount(e);
            }, allowNull: true }),
        React.createElement(DateInput, { placeholder: lang.tribunal.distraintDate, allowNull: true, value: date, onChange: (d) => {
                setdate(d);
            } }),
        React.createElement(Input, { placeholder: lang.tribunal.distraintReferenceId, value: referenceId || undefined, onChange: (e) => {
                setReferenceId(e.target.value);
            } }),
        React.createElement(Button, { onClick: registerDistress, loading: loading, disabled: distraintType == null, block: true }, lang.tribunal.registerDistraint)));
};
export default RegisterDistraint;
//# sourceMappingURL=Distraint.js.map